import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m2.477 12.933 9.857 6.878a1.043 1.043 0 0 0 1.486-.31c.117-.185.18-.401.18-.623V5.122C14 4.502 13.52 4 12.928 4c-.211 0-.418.066-.594.188l-9.857 6.879c-.492.343-.625 1.04-.297 1.555.079.123.18.23.297.311Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21 4h-2.889a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1H21a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Z"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=StepBackwardIcon24.js.map